import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// ============================================
// Utilities from Next.js project
// ============================================

export const sleep = async (ms: number) => {
  await new Promise((resolve) => setTimeout(resolve, ms));
};

export function typedObjectEntries<T extends object>(obj: T): Array<[keyof T, T[keyof T]]> {
  return Object.entries(obj) as Array<[keyof T, T[keyof T]]>;
}

const sum = (base: string) => {
  let sum = 0,
    mul = 2,
    l = 14;
  for (let i = 0; i < l; i++) {
    const digit = base.substring(l - i - 1, l - i);
    const tp = parseInt(digit, 10) * mul;
    if (tp >= 10) sum += (tp % 10) + 1;
    else sum += tp;
    if (mul === 1) mul++;
    else mul--;
  }
  return sum;
};

export function isImei(imei: string): boolean {
  var etal = /^[0-9]{15}$/;
  if (!etal.test(imei)) return false;
  const _sum = sum(imei);
  const chk = (10 - (_sum % 10)) % 10;
  if (chk !== parseInt(imei.substring(14, 15), 10)) return false;
  return true;
}

interface IGenerateImei {
  tac: number;
  snr: number;
}

export function generateImei(input: IGenerateImei) {
  const { tac, snr } = input;
  const base = tac + snr.toString().padStart(6, '0');
  const _sum = sum(base);
  const chk = (10 - (_sum % 10)) % 10;
  return base + chk;
}

export const isIccid = (input: string) => /^[a-zA-Z0-9]{19,20}$/.test(input);

/** Force-download a file from a URL instead of opening it in a new tab */
export async function downloadFromUrl(url: string, fileName: string): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(blobUrl);
}
